import styled from 'styled-components';

import { Colors } from 'components/utils/styles/ui';

import { Header } from './index';

export {
  ButtonGroup,
  CheckboxWrapper,
  Description,
  Footer,
  Submit,
  WarningBox,
} from './index';

export const BackupCodesWrapper = styled.div`
  padding: 2rem 4rem 3rem 4rem;
  width: 60rem;
  border-radius: 0.6rem;
  background-color: ${Colors.white};
  color: ${Colors.text};
`;

export const BackupCodesHeader = styled(Header)`
  margin: 0.5rem 0 2rem 0;
`;

export const CodesContainer = styled.div`
  background-color: ${Colors.greyLighter};
  border: 1px solid ${Colors.grey};
  border-radius: 0.6rem;
  padding: 2rem;
  margin: 0 0 1.5rem 0;
`;

export const CodesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

export const Code = styled.div`
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 1.2rem;
  padding: 0.8rem 1rem;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.grey};
  border-radius: 0.4rem;
  text-align: center;
  letter-spacing: 0.1em;
  user-select: all;
`;
